export const DIRECTIONS = {
    LEFT: 'LEFT',
    RIGHT: 'RIGHT',
}
